<template>
  <div class="footer-menu" :style="{ 'background-color': backgroundColor }">
    <v-row no-gutters class="px-0">
      <v-col
        cols="3"
        class="menu-items pb-0 pr-0"
        v-for="item in menuItems"
        :key="item.icon"
        @click="item.disabled ? '' : goTo(item.name)"
      >
        <div class="tag" v-if="item.tag">
          {{ item.tag }}
        </div>
        <v-icon class="icon" :color="item.disabled ? '#8a8a8a' : '#fff'" size="24">{{ item.icon }}</v-icon>
        <div class="active-menu-item" v-if="$route.name === item.name"></div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'FooterMenu',
  computed: {
    ...mapGetters('user', ['colorTheme', 'enableTelemedicina'])
  },
  data() {
    return {
      menuItems: [
        {
          icon: 'mdi-home-variant-outline',
          name: '/dashboard'
        },
        {
          icon: 'mdi-heart-outline',
          name: '/agendamentos'
        },
        {
          icon: 'mdi-file-document-multiple-outline',
          name: '/atestado'
        },
        {
          icon: 'mdi-account',
          name: '/minha-conta'
        }
      ],
      backgroundColor: this.$vuetify.theme.themes.light.primary
    }
  },
  methods: {
    goTo(route) {
      this.$router.push({ path: route })
    }
  },
  created() {
    this.backgroundColor = this.colorTheme
  }
}
</script>

<style scoped>
.footer-menu {
  height: 53px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  z-index: 999;
  position: sticky;
  bottom: 0;
  overflow-y: visible;
  padding: 5px !important;
}
.menu-items {
  display: flex;
  justify-content: center !important;
  align-items: center !important;
  flex-direction: column;
  overflow: hidden;
  margin-top: 5px;
}
.icon:hover {
  cursor: pointer;
}
.active-menu-item {
  height: 5px;
  width: 5px;
  background-color: #fff;
  border-radius: 50%;
  display: inline-block;
  position: absolute;
  bottom: 0;
  margin-bottom: 10px;
}
.agendar {
  background-color: #ffba00;
  height: 55px;
  width: 55px;
  border-radius: 50%;
  text-align: center;
  vertical-align: middle;
  display: flex;
  margin-top: -60px;
  margin-right: auto;
  margin-left: auto;
  border: 4px solid #fff;
  justify-content: center;
  align-items: center;
}
.agendar:hover {
  transform: scale(1.05);
  cursor: pointer;
}
.tag {
  background-color: #28a038;
  color: #fff;
  font-size: 0.6rem;
  position: absolute;
  bottom: 0;
  padding: 0px 5px;
  border-radius: 10px;
  z-index: 9999;
  margin-bottom: 5px;
}
@media only screen and (min-width: 960px) {
  .footer-menu {
    height: 60px;
  }
  .agendar {
    height: 70px;
    width: 70px;
  }
  .tag {
    margin-bottom: 10px;
  }
}
</style>
